import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { patchCurrentUser } from 'src/state/users'
import { UserPatchType } from '@meniudigital/shared'
import Button from 'src/global/Button'
import { useNavigate } from 'react-router-dom'
import { Screen } from 'src/screens'
import OrderWidgetPreview from 'src/screens/ConfigureOrderWidgetScreen/OrderWidgetPreview/index'
import Setting from '../Setting'
import { IS_DESKTOP_OR_TABLET } from '../..'

export default function WidgetSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)
  const navigate = useNavigate()

  const goToWidgetConfigurator = () => {
    window.hideSettingsModal()
    navigate(Screen.ConfigureOrderWidget)
  }

  if (!user) {
    return null
  }

  const toggleWidget = () => {
    const newConfig = {
      ...(user.orderWidget || { discountPercent: 0, whenToDisplay: 'always', buttons: [] }),
      isEnabled: !user.orderWidget?.isEnabled,
    }
    const payload = {
      type: UserPatchType.OrderWidgetConfig,
      data: newConfig,
    }
    dispatch(patchCurrentUser(payload as any))
  }

  const orderWidgetConfig = user.orderWidget || { discountPercent: 0, whenToDisplay: 'always' as const, buttons: [] }

  return (
    <>
      <div className="setting-question">Dorești afișarea widgetului de comenzi online pe meniu?</div>
      <Setting
        title={IS_DESKTOP_OR_TABLET ? "Widget de Comenzi Online" : "Widget Comenzi Online"}
        iconPath="/icons/widget.png"
        isEnabled={user.orderWidget?.isEnabled}
        onToggle={toggleWidget}
        toggleTexts={{ on: 'Afișat pe meniu', off: 'Ascuns' }}
        body={
          <>
            <OrderWidgetPreview
              config={orderWidgetConfig}
              restaurantName={(user.name || '').trim() || 'Restaurantul Tău'}
              showLabel={false}
            />
            <Button variant="as-text" text="Configurează..." onClick={goToWidgetConfigurator} />
          </>
        }
        alwaysShowsBody
        infoText="Widgetul de comenzi online oferă clienților butoane rapide către site, telefon sau platformele de livrare. Va fi poziționat pe meniu, în partea de jos."
        withBullet
      />
    </>
  )
}
